<template>
    <div id="stadiafr-jeux-login">
        <template v-if="is_loading">
            <Loader />
        </template>

        <template v-else>
            <div class="logo"></div>
            <div class="wordings">
                Vous devez vous connecter avec votre compte Discord pour accéder aux Stadia Fr Awards.
            </div>
            <img src="/public/assets/images/discord-logo.png" v-on:click="discordLogo_clicked" />
        </template>
    </div>
</template>

<script>
import Loader from '../../components/Loader.vue';

export default {
    name: "Login",
    components: {
        Loader
    },
    data: () => ({
        is_loading: false
    }),
    methods: {
        discordLogo_clicked: function(event) {
            document.location.href = 'https://discord.com/api/oauth2/authorize?client_id=793175355220557844&redirect_uri=https%3A%2F%2Fjeux.stadiafr.com%2Flogin&response_type=code&scope=identify';
        },
        // UTILS
        getParameterByName: function(name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    },
    mounted() {
        const discord_auth_code = this.getParameterByName('code');
        if (discord_auth_code) {
            this.is_loading = true;

            this.$store.dispatch('authentication/requestToken', discord_auth_code)
                .then(() => {
                    this.$router.push({ name: 'awards' }).catch((error) => { console.error(error); });
                })
                .catch((error) => {
                    this.is_loading = false;          
                });
        }
    }
}
</script>